var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-light app-height",attrs:{"fluid":""}},[_c('router-view',{attrs:{"route":_vm.route,"routes":_vm.routeOrders,"vrooms":_vm.vrooms},on:{"changeRoute":_vm.changeRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }